import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { State, UserCityResponse, UserRoleResponse, UserStateResponse } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';

/// GET roles LIST
export type DTO1 = {
    search?: string;
};

export const getUserRole = (
    { search }: DTO1 = {
    }
  ): Promise<UserRoleResponse> => {
    return axios.get(`/role-list`);
  };


type UseOptions = {
  config?: MutationConfig<typeof getUserRole>;
};

export const useGetUserRoleList= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getUserRole,
  });
};



//////Get state list

export type DTO2 = {
    search?: string;
};

export const getStateList = (
    { search }: DTO2 = {
    }
  ): Promise<UserStateResponse> => {
    return axios.get(`/state-list`);
  };


type UseOptions2 = {
  config?: MutationConfig<typeof getStateList>;
};

export const useGetStateList= ({ config }: UseOptions2 = {}) => {
  return useMutation({
    ...config,
    mutationFn: getStateList,
  });
};


/// Get city list

export type DTO3 = {
    id?: string;
};

export const getCityList = (
    { id }: DTO3 = {
    }
  ): Promise<UserCityResponse> => {
    return axios.get(`/${id}/city-list`,  {
      
     });
  };


type UseOptions3 = {
  config?: MutationConfig<typeof getCityList>;
};

export const useGetCityList= ({ config }: UseOptions3 = {}) => {
  return useMutation({
    ...config,
    mutationFn: getCityList,
  });
};



/// Get managers list


export const getManagersList = (
    { id }: DTO3 = {
    }
  ): Promise<UserRoleResponse> => {
    return axios.get(`/superadmin/get-manager/${id}`,  {
      
     });
  };


type UseOptions4 = {
  config?: MutationConfig<typeof getManagersList>;
};

export const useGetManagerList= ({ config }: UseOptions4 = {}) => {
  return useMutation({
    ...config,
    mutationFn: getManagersList,
  });
};
